<i class="ui-caution-custom" ui-icon uiType="caution"></i>
